// some helper function for modify leaderboard data structure,
// array , object operation

export const groupByUser = (array) => {
    const groupByUserObject = array.reduce((acc, currentItem) => {
        const student_id = currentItem.student_id;
        if (!acc[student_id]) {
            acc[student_id] = [];
        }
        acc[student_id].push(currentItem);
        return acc;
    }, {});
    return Object.values(groupByUserObject);
}

export const calculateTotalMark = (array, nameOfProperty) => {
    const totalMarkCalculatedArray = array.map(item => {
        return item.reduce((finalMark, cur) =>
        ({
            student_id: cur.student_id,
            student_name: cur.student_name,
            [nameOfProperty]: cur.mark + finalMark[nameOfProperty]
        })
            , { [nameOfProperty]: 0 })
    })
    return totalMarkCalculatedArray
}

export const arrayOfObjectMerge = (array1, array2) => {
    const output = array1.map(obj1 => {
        const obj2 = array2.find(obj2 => obj2.student_id === obj1.student_id);
        return { ...obj1, ...obj2 };
    }).concat(array2.filter(obj2 => !array1.some(obj1 => obj1.student_id === obj2.student_id)));
    return output
}

export const mergeWithAllUsers = (users, array2) => {
    const removeAdminFromUser = users.filter(user=>user.role !== "admin")
    const output = removeAdminFromUser.map(obj1 => {
        const obj2 = array2.find(obj2 => obj2.student_id === obj1.id);
        if(obj2){
            return {...obj2 };
        }else{
            return {student_id: obj1.id, student_name: obj1.name}
        }

    })
    return output
}

export const arraySortAndSerialize = (array) => {

    const serialMap = new Map();
    let currentSerial = 1;

    const sortedArray = array
        .map(obj => {
            const totalMark = (obj.totalQuizMark ? obj.totalQuizMark : 0) + (obj.totalAssignmentMark ? obj.totalAssignmentMark : 0);
            return { ...obj, totalMark };
        })
        .sort((a, b) => (b.totalMark) - (a.totalMark))
        .map((obj) => {
            const totalMark = obj.totalMark
            let serial;

            if (serialMap.has(totalMark)) {
                serial = serialMap.get(totalMark);
            } else {
                serial = currentSerial;
                serialMap.set(totalMark, currentSerial);
                currentSerial++;
            }

            return { ...obj, serial };
        });
    return sortedArray
}